<template>
    <div class="p-3">
        <div class="row mb-2">
            <div class="col">
                <a :href="'/contacts/create?participant_id='+participant.id" class="btn btn-primary btn-sm">Add Contact</a>
            </div>
        </div>
        <div class="row row-cols-1">
            <alternate-contact-card
                v-for="contact in contacts" 
                :key="contact.id"
                :contact="contact" 
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import AlternateContactCard from './AlternateContactCard'

export default {
    name: "AlternateContactList",
    components: {
        AlternateContactCard
    },
    props: { 
        participant: Object,
    },
    computed: {
        ...mapState({
            contacts: state => state.contacts.contacts
        })
    },
    mounted () {
    	this.$store.dispatch('contacts/setParticipant', this.participant)
        this.$store.dispatch('contacts/setContacts', this.participant.contacts)
    }
}

</script>